import {
    DEVICES_BULK_ACTIONS_OPEN_MODAL,
    DEVICES_BULK_ACTIONS_CLOSE_MODAL,
    DEVICES_BULK_ACTIONS_SEARCH_DEVICES_REQUEST,
    DEVICES_BULK_ACTIONS_SEARCH_DEVICES_RESULT,
    DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_REQUEST,
    DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_RESULT,
    DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_REQUEST,
    DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_RESULT,
    DEVICES_BULK_SEND_MESSAGE_REQUEST,
    DEVICES_BULK_SEND_MESSAGE_RESULT,
    DEVICES_BULK_ACTIONS_REQUEST,
    DEVICES_BULK_ACTIONS_RESULT,
    DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_REQUEST,
    DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_RESULT,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    result: null,
    error: null,
    devicesLoading: false,
    devices: [],
    devicesModels: [],
    devicesModelsLoading: false,
    commands: { manufacturer: null, unitTypes: [], deviceModels: [] },
    commandsLoading: false,
    sendCommandLoading: false,
    sendCommand: null,
    bulkFeatures: false,
    supportedTimezones: []
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {

        case DEVICES_BULK_SEND_MESSAGE_REQUEST:
            return { ...state, sendCommandLoading: true }
        case DEVICES_BULK_SEND_MESSAGE_RESULT:
            return { ...state, sendCommandLoading: false, sendCommand: action.payload }

        case DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_REQUEST:
            return { ...state, commandsLoading: true }

        case DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_RESULT:
            return { ...state, commandsLoading: false, commands: action.payload }

        case DEVICES_BULK_ACTIONS_REQUEST:
            return { ...state, loading: true }

        case DEVICES_BULK_ACTIONS_RESULT:
            return { ...state, loading: false, result: action.payload }

        case DEVICES_BULK_ACTIONS_OPEN_MODAL:
            return { ...state, openModal: true, devices: action?.payload?.devices || [], bulkFeatures: action?.payload?.bulkFeatures || false }

        case DEVICES_BULK_ACTIONS_CLOSE_MODAL:
            return { ...state, openModal: false }

        case DEVICES_BULK_ACTIONS_SEARCH_DEVICES_REQUEST:
            return { ...state, devicesLoading: true }

        case DEVICES_BULK_ACTIONS_SEARCH_DEVICES_RESULT:
            return { ...state, devicesLoading: false, devices: action.payload }

        case DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_REQUEST:
            return { ...state, devicesModelsLoading: true }
        case DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_RESULT:
            return { ...state, devicesModelsLoading: false, devicesModels: action.payload.items, supportedTimezones: action.payload.timezones }

        case DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_REQUEST:
            return { ...state, loading: true }
        case DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_RESULT:
            return { ...state, loading: false, supportedTimezones: action.payload }

        case CLEAR_REDUX:
            return ["", "BULK_ACTIONS"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};